export const SELECTED_TIME_RANGE_CODE = {
  CUSTOM: 0,
  CURRENT_ITERATION: 1,
  RETROSPECT: 2
};
